import { useMutation, useQueryClient } from '@tanstack/vue-query';

import { useExperienceApi } from '@/shared/api/useExperienceApi';

interface SubmitTravelerRatingParams {
  reviewHash: string;
  rate: number;
}

export const useSubmitTravelerRating = () => {
  const { submitTravelerReview } = useExperienceApi();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['submitTravelerReview'],
    mutationFn: async ({ reviewHash, rate }: SubmitTravelerRatingParams) => {
      const result = await submitTravelerReview({
        path: { review_hash: reviewHash },
        body: { rate, platform: 'web' },
      });

      if (!result.response.ok) {
        throw new Error(`Failed to submit rating: ${String(result.response.status)}`);
      }

      return result;
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['travelerOrders'] });
    },
  });

  return {
    submitRating: mutateAsync,
    isSubmitting: isPending,
  };
};
